import { FC } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

interface ExportHistoryErrorProps {
  onRetry: () => void;
}

export const ExportHistoryError: FC<ExportHistoryErrorProps> = ({
  onRetry,
}) => {
  return (
    <Fade in={true} timeout={400}>
      <Box sx={{ py: 12 }}>
        <Stack direction="column" alignItems="center" spacing={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            width={120}
            height={120}
            borderRadius="50%"
            bgcolor="error.50"
            color="error.main"
          >
            <ErrorOutlineIcon sx={{ fontSize: 120 }} />
          </Stack>
          <Typography
            variant="h4"
            align="center"
            color="text.primary"
            fontWeight={600}
          >
            Something went wrong
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary">
            Unable to load export history. Please try again.
          </Typography>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
            sx={{ mt: 1 }}
          >
            Try again
          </Button>
        </Stack>
      </Box>
    </Fade>
  );
};
